import { queryOptions } from "@tanstack/react-query";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import type { McpServer } from "../types";
import { mcpGatewaysKeys } from "./query-keys";

const fetchMCPGateways = async ({
  client,
}: {
  client: ApiClient;
}): Promise<McpServer[]> => {
  const { data } = await client.get<{ items?: McpServer[] } | McpServer[]>(
    "/gateways"
  );
  if (Array.isArray(data)) {
    return data;
  }
  return data?.items ?? [];
};

export const mcpGatewaysQueryOptions = ({
  binding = "project",
  scope,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<McpServer[]>({
    queryKey: mcpGatewaysKeys.list({ binding, scope }),
    queryFn: () => fetchMCPGateways({ client }),
  });
};
